import { useEffect, useReducer } from "react";

import usePlayer from "./usePlayer";

const INITIAL_STATE = { completed: false };
const SUBSCRIBED_EVENTS = ["play", "pause", "complete", "seek", "seeked"];
export const PLAYBACK_CONTROLLER_ACTIONS = {
  PLAY: "play",
  PAUSE: "pause",
};

function reducer(state, action) {
  switch (action.type) {
    case "play":
      return {
        playing: true,
        paused: false,
        completed: false,
        seeking: false,
        seeked: false,
      };
    case "pause":
      return {
        playing: false,
        paused: true,
        completed: false,
        seeking: false,
        seeked: false,
      };
    case "complete":
      return {
        playing: false,
        paused: false,
        completed: true,
        seeking: false,
        seeked: false,
      };
    case "seek":
      return {
        playing: false,
        paused: false,
        completed: false,
        seeking: true,
        seeked: false,
      };
    case "seeked":
      return {
        playing: false,
        paused: false,
        completed: false,
        seeking: false,
        seeked: true,
      };
    default:
      throw new Error(`Unhandled action type: ${action.type}`);
  }
}

function usePlaybackState() {
  const player = usePlayer();
  const [state, dispatch] = useReducer(reducer, INITIAL_STATE);

  useEffect(() => {
    if (player.isReady) {
      const currentPlaybackState = player.getState();
      if (currentPlaybackState === "playing") {
        dispatch({ type: "play" });
      } else if (currentPlaybackState === "paused") {
        dispatch({ type: "pause" });
      }

      SUBSCRIBED_EVENTS.forEach((event) => {
        player.on(event, () => {
          dispatch({ type: event });
        });
      });
    }
    return () => {
      if (player.isReady) {
        SUBSCRIBED_EVENTS.forEach((event) => {
          player.off(event);
        });
      }
    };
  }, [player]);

  return state;
}

function usePlaybackController() {
  const player = usePlayer();

  function dispatch(action) {
    if (!player.isReady) return undefined;
    switch (action.type) {
      case PLAYBACK_CONTROLLER_ACTIONS.PLAY:
        return player.play();
      case PLAYBACK_CONTROLLER_ACTIONS.PAUSE:
        return player.pause();
      default:
        throw new Error(`Unhandled action type: ${action.type}`);
    }
  }

  return dispatch;
}

export default function usePlayback() {
  return [usePlaybackState(), usePlaybackController()];
}
